/**
 * ActiveJobsIndicator - Indicateur global des jobs actifs
 * 
 * Affiche un badge dans la navigation quand des jobs sont en cours.
 * Permet de voir la progression sans être sur la page CreateArticle.
 */

import React from 'react';
import { useJobs } from '../contexts/JobContext';
import { Loader2, CheckCircle2, AlertCircle } from 'lucide-react';

const ActiveJobsIndicator = ({ className = '' }) => {
  const { activeJobs, getActiveJobsList } = useJobs();
  
  const activeList = getActiveJobsList();
  const activeCount = activeList.length;
  
  if (activeCount === 0) return null;
  
  // Calculer la progression globale
  const totalSites = activeList.reduce((sum, j) => sum + (j.total_sites || 0), 0);
  const completedSites = activeList.reduce((sum, j) => sum + (j.completed_sites || 0), 0);
  const progressPercent = totalSites > 0 ? Math.round((completedSites / totalSites) * 100) : 0;
  
  return (
    <div className={`flex items-center gap-2 px-2 py-1 rounded-lg bg-sky-500/20 border border-sky-500/30 ${className}`}>
      <Loader2 className="w-4 h-4 text-sky-400 animate-spin" />
      <span className="text-xs font-mono text-sky-300">
        {activeCount} job{activeCount > 1 ? 's' : ''} • {progressPercent}%
      </span>
      <div className="w-12 h-1.5 bg-slate-700 rounded-full overflow-hidden">
        <div 
          className="h-full bg-sky-400 transition-all duration-300"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
};

export default ActiveJobsIndicator;
